import React from "react";

export function MapPinIcon({
  size = 20,
  color = "currentColor",
  style,
  ...props
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="52"
      height="60"
      viewBox="0 0 52 60"
      fill="none"
    >
      <g filter="url(#filter0_d_3656_16709)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M26 4C37.598 4 47 13.402 47 25C47 33.8926 41.4727 41.4942 33.6663 44.5567L27.1961 53.4007C27.0612 53.5858 26.8821 53.7369 26.6739 53.8412C26.4657 53.9455 26.2346 54 26 54C25.7654 54 25.5343 53.9455 25.3261 53.8412C25.1179 53.7369 24.9388 53.5858 24.8039 53.4007L18.3337 44.5567C10.5273 41.4941 5 33.8926 5 25C5 13.402 14.402 4 26 4Z"
          fill="white"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_3656_16709"
          x="0"
          y="0"
          width="52"
          height="60"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="2.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_3656_16709"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_3656_16709"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}

export function MapPin2Icon({
  size = 20,
  color = "currentColor",
  style,
  ...props
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="52"
      height="60"
      viewBox="0 0 52 60"
      fill="none"
    >
      <g filter="url(#filter0_d_3656_14823)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M26 4C37.598 4 47 13.402 47 25C47 33.8926 41.4727 41.4942 33.6663 44.5567L27.1961 53.4007C27.0612 53.5858 26.8821 53.7369 26.6739 53.8412C26.4657 53.9455 26.2346 54 26 54C25.7654 54 25.5343 53.9455 25.3261 53.8412C25.1179 53.7369 24.9388 53.5858 24.8039 53.4007L18.3337 44.5567C10.5273 41.4941 5 33.8926 5 25C5 13.402 14.402 4 26 4Z"
          fill="white"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_3656_14823"
          x="0"
          y="0"
          width="52"
          height="60"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="2.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_3656_14823"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_3656_14823"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}

export function MapMeIcon({
  size = 20,
  color = "currentColor",
  style,
  ...props
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
    >
      <path
        d="M25 50C38.8071 50 50 38.8071 50 25C50 11.1929 38.8071 0 25 0C11.1929 0 0 11.1929 0 25C0 38.8071 11.1929 50 25 50Z"
        fill="#3478F5"
        fillOpacity="0.2"
      />
      <path
        d="M25 37C31.6274 37 37 31.6274 37 25C37 18.3726 31.6274 13 25 13C18.3726 13 13 18.3726 13 25C13 31.6274 18.3726 37 25 37Z"
        fill="white"
      />
      <path
        d="M25 35C30.5228 35 35 30.5228 35 25C35 19.4772 30.5228 15 25 15C19.4772 15 15 19.4772 15 25C15 30.5228 19.4772 35 25 35Z"
        fill="#2E90FA"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30 13L25 9L20 13C21.5782 12.5413 23.2578 12.294 25 12.294C26.7422 12.294 28.4218 12.5413 30 13Z"
        fill="#2E90FA"
      />
    </svg>
  );
}

export function MapHomeIcon({
  size = 20,
  color = "currentColor",
  style,
  ...props
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.99999 5.33268C6.52723 5.33268 5.33332 6.52659 5.33332 7.99935C5.33332 9.47211 6.52723 10.666 7.99999 10.666C9.47275 10.666 10.6667 9.47211 10.6667 7.99935C10.6667 6.52659 9.47275 5.33268 7.99999 5.33268ZM6.66666 7.99935C6.66666 7.26297 7.26361 6.66602 7.99999 6.66602C8.73637 6.66602 9.33332 7.26297 9.33332 7.99935C9.33332 8.73573 8.73637 9.33268 7.99999 9.33268C7.26361 9.33268 6.66666 8.73573 6.66666 7.99935Z"
        fill="#252525"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.66666 0.666016V2.03597C11.4477 2.3434 13.6559 4.5516 13.9634 7.33268H15.3333V8.66602H13.9634C13.6559 11.4471 11.4477 13.6553 8.66666 13.9627V15.3327H7.33332V13.9627C4.55225 13.6553 2.34404 11.4471 2.03661 8.66602H0.666656V7.33268H2.03661C2.34404 4.5516 4.55225 2.3434 7.33332 2.03597V0.666016H8.66666ZM7.99999 3.33268C5.42266 3.33268 3.33332 5.42202 3.33332 7.99935C3.33332 10.5767 5.42266 12.666 7.99999 12.666C10.5773 12.666 12.6667 10.5767 12.6667 7.99935C12.6667 5.42202 10.5773 3.33268 7.99999 3.33268Z"
        fill="#252525"
      />
    </svg>
  );
}
